// extracted by mini-css-extract-plugin
module.exports = {"component":"icon_1U8oR","isActive":"icon_1fwQH"};